module.exports = __webpack_public_path__ + "img/active-1.ebbe1d59.png";